/* ============================================================
   Build Your Routine — Skin / Tan / Base dynamic bundle builder
   Isolated from Summer Skin (no bsp maps / selectors).
   Phase 2 cart: three lines + _bundle_* / __bundle_* properties for Phase 3 CT.
   ============================================================ */

(function () {
  'use strict';

  var root = document.querySelector('[data-byr-bundle]');
  if (!root) return;

  var roles = (root.getAttribute('data-byr-roles') || 'skin,tan,base')
    .split(',')
    .map(function (r) { return r.trim(); })
    .filter(Boolean);
  if (roles.length !== 3) {
    roles = ['skin', 'tan', 'base'];
  }
  var campaignId = root.getAttribute('data-campaign-id') || 'build-your-routine-july-2026';
  var parentVariantId = root.getAttribute('data-parent-variant-id') || '';
  var bundlePriceCents = root.getAttribute('data-bundle-price-cents') || '';
  var priceFromMainComponent =
    root.getAttribute('data-price-from-main-component') === 'true';
  var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';

  var state = {
    skin: emptyRole(),
    tan: emptyRole(),
    base: emptyRole(),
  };

  function emptyRole() {
    return { productId: null, variantId: null, priceCents: 0 };
  }

  var stepEls = root.querySelectorAll('[data-byr-step]');
  var atcBtn = root.querySelector('[data-byr-atc]');
  var atcTextEl = root.querySelector('[data-byr-atc-text]');
  var errorEl = root.querySelector('[data-byr-error]');
  var qtyInput = root.querySelector('[data-byr-qty]');
  var priceEl = root.querySelector('[data-byr-price]');

  /* ── Helpers ───────────────────────────────────────────── */

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, (cents / 100).toFixed(2));
  }

  function getQty() {
    var q = parseInt(qtyInput && qtyInput.value, 10);
    return q && q > 0 ? q : 1;
  }

  function roleIndex(role) {
    return roles.indexOf(role);
  }

  function isStepComplete(role) {
    return !!(state[role] && state[role].variantId);
  }

  function completedCount() {
    var n = 0;
    roles.forEach(function (r) {
      if (isStepComplete(r)) n += 1;
    });
    return n;
  }

  function isReady() {
    return completedCount() === 3;
  }

  function nextIncompleteRole() {
    for (var i = 0; i < roles.length; i++) {
      if (!isStepComplete(roles[i])) return roles[i];
    }
    return null;
  }

  function isStepLocked(role) {
    var idx = roleIndex(role);
    if (idx <= 0) return false;
    for (var i = 0; i < idx; i++) {
      if (!isStepComplete(roles[i])) return true;
    }
    return false;
  }

  function stepEl(role) {
    return root.querySelector('[data-byr-step="' + role + '"]');
  }

  /* ── Accordion ─────────────────────────────────────────── */

  function setStepOpen(role, on) {
    var step = stepEl(role);
    if (!step) return;
    var hdr = step.querySelector('[data-byr-toggle]');
    step.classList.toggle('byr__step--open', on);
    if (hdr) hdr.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  function openStep(role) {
    roles.forEach(function (r) {
      setStepOpen(r, r === role);
    });
  }

  function syncStepClasses() {
    roles.forEach(function (role) {
      var step = stepEl(role);
      if (!step) return;
      var locked = isStepLocked(role);
      step.classList.toggle('byr__step--locked', locked);
      step.classList.toggle('byr__step--complete', isStepComplete(role));
      var toggleBtn = step.querySelector('[data-byr-toggle]');
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-disabled', locked ? 'true' : 'false');
      }
    });
  }

  /* ── Reset / selection ─────────────────────────────────── */

  function clearRoleUi(role) {
    var step = stepEl(role);
    if (!step) return;
    step.querySelectorAll('[data-byr-product]').forEach(function (card) {
      card.classList.remove('byr__product-card--active');
    });
    step.querySelectorAll('.byr__variant').forEach(function (v) {
      v.classList.remove('byr__variant--active');
    });
    exitOptionMode(step);
    updateStepSummary(role);
  }

  /**
   * Paint collapsed-header summary from active product/variant DOM.
   * @param {string} role
   */
  function updateStepSummary(role) {
    var step = stepEl(role);
    if (!step) return;
    var slot = step.querySelector('[data-byr-step-summary]');
    if (!slot) return;

    while (slot.firstChild) {
      slot.removeChild(slot.firstChild);
    }

    if (!state[role] || !state[role].variantId) {
      slot.hidden = true;
      return;
    }

    var card = step.querySelector(
      '[data-byr-product].byr__product-card--active'
    );
    if (!card) {
      slot.hidden = true;
      return;
    }

    var nameEl = card.querySelector('.byr__product-card-name');
    var productTitle = nameEl ? nameEl.textContent.trim() : '';
    var imgEl = card.querySelector('.byr__product-card-img');

    var variantTitle = '';
    var activeVar = step.querySelector('.byr__variant--active');
    if (activeVar) {
      var varLabel =
        activeVar.querySelector('.byr__swatch-code') ||
        activeVar.querySelector('.byr__variant-text');
      if (varLabel) {
        variantTitle = varLabel.textContent.trim();
      }
    }
    if (
      !variantTitle ||
      variantTitle === 'Default Title' ||
      variantTitle === productTitle
    ) {
      variantTitle = '';
    }

    if (imgEl && imgEl.getAttribute('src')) {
      var thumb = document.createElement('img');
      thumb.className = 'byr__step-summary-img';
      thumb.src = imgEl.currentSrc || imgEl.src;
      thumb.alt = imgEl.alt || productTitle;
      thumb.width = 28;
      thumb.height = 28;
      slot.appendChild(thumb);
    }

    var text = document.createElement('span');
    text.className = 'byr__step-summary-text';
    text.textContent = variantTitle
      ? productTitle + ' · ' + variantTitle
      : productTitle;
    slot.appendChild(text);

    slot.hidden = false;
  }

  function resetAfter(role) {
    var idx = roleIndex(role);
    for (var i = idx + 1; i < roles.length; i++) {
      var r = roles[i];
      state[r] = emptyRole();
      clearRoleUi(r);
      setStepOpen(r, false);
    }
  }

  function exitOptionMode(step) {
    if (!step) return;
    step.classList.remove('byr__step--picking-option');
    step.querySelectorAll('[data-byr-option-view]').forEach(function (view) {
      view.hidden = true;
    });
  }

  function enterOptionMode(step, productId) {
    if (!step) return;
    step.classList.add('byr__step--picking-option');
    step.querySelectorAll('[data-byr-option-view]').forEach(function (view) {
      var match = view.getAttribute('data-byr-option-view') === String(productId);
      view.hidden = !match;
      if (!match) {
        view.querySelectorAll('.byr__variant').forEach(function (v) {
          v.classList.remove('byr__variant--active');
        });
      }
    });
  }

  function selectVariant(role, variantId, priceCents) {
    state[role].variantId = String(variantId);
    state[role].priceCents = parseInt(priceCents, 10) || 0;

    var step = stepEl(role);
    if (step) {
      step.querySelectorAll('.byr__variant').forEach(function (btn) {
        btn.classList.toggle(
          'byr__variant--active',
          btn.getAttribute('data-variant-id') === String(variantId)
        );
      });
      exitOptionMode(step);
    }

    completeStep(role);
  }

  function completeStep(role) {
    syncStepClasses();
    updateStepSummary(role);
    updatePriceDisplay();
    updateAtc();

    var next = nextIncompleteRole();
    if (next) {
      openStep(next);
    } else {
      roles.forEach(function (r) {
        setStepOpen(r, false);
      });
    }
  }

  function selectProduct(role, card) {
    if (isStepLocked(role)) return;

    var productId = card.getAttribute('data-product-id');
    var availableCount = parseInt(card.getAttribute('data-available-count'), 10) || 0;
    var changed = String(state[role].productId) !== String(productId);

    if (changed) {
      resetAfter(role);
      state[role] = emptyRole();
      state[role].productId = productId;
    } else {
      state[role].productId = productId;
    }

    var step = stepEl(role);
    if (!step) return;

    step.querySelectorAll('[data-byr-product]').forEach(function (c) {
      c.classList.toggle(
        'byr__product-card--active',
        c.getAttribute('data-product-id') === productId
      );
    });

    if (availableCount === 1) {
      exitOptionMode(step);
      var variantId = card.getAttribute('data-variant-id');
      var priceCents = card.getAttribute('data-price-cents');

      if (
        !changed &&
        String(state[role].variantId) === String(variantId)
      ) {
        openStep(role);
        syncStepClasses();
        updatePriceDisplay();
        updateAtc();
        return;
      }

      selectVariant(role, variantId, priceCents);
      return;
    }

    if (changed) {
      state[role].variantId = null;
      state[role].priceCents = 0;
    }

    enterOptionMode(step, productId);

    if (changed) {
      var view = step.querySelector(
        '[data-byr-option-view="' + productId + '"]'
      );
      if (view) {
        view.querySelectorAll('.byr__variant').forEach(function (v) {
          v.classList.remove('byr__variant--active');
        });
      }
    } else if (state[role].variantId) {
      step.querySelectorAll('.byr__variant').forEach(function (btn) {
        btn.classList.toggle(
          'byr__variant--active',
          btn.getAttribute('data-variant-id') === String(state[role].variantId)
        );
      });
    }

    openStep(role);
    syncStepClasses();
    updatePriceDisplay();
    updateAtc();
  }

  function onVariantClick(role, btn) {
    if (isStepLocked(role)) return;

    var variantId = btn.getAttribute('data-variant-id');
    var priceCents = btn.getAttribute('data-price-cents');
    var prevVariantId = state[role].variantId;
    var changed = String(prevVariantId) !== String(variantId);

    if (changed) {
      resetAfter(role);
    }

    var view = btn.closest('[data-byr-option-view]');
    if (view) {
      state[role].productId = view.getAttribute('data-byr-option-view');
    }

    if (!changed && prevVariantId) {
      openStep(role);
      syncStepClasses();
      updatePriceDisplay();
      updateAtc();
      return;
    }

    selectVariant(role, variantId, priceCents);
  }

  /* ── Price / ATC ───────────────────────────────────────── */

  /**
   * Sum of selected component variant prices (cents).
   * @returns {number}
   */
  function getSelectedItemsSumCents() {
    var sum = 0;
    roles.forEach(function (r) {
      if (state[r].variantId) {
        sum += state[r].priceCents || 0;
      }
    });
    return sum;
  }

  /**
   * Resolve sell / __bundle_price cents.
   * Default: main product price. When priceFromMainComponent is on,
   * use the sum of all selected component prices.
   * @returns {number}
   */
  function getBundlePriceCents() {
    if (priceFromMainComponent) {
      return getSelectedItemsSumCents();
    }

    var sell = parseInt(bundlePriceCents, 10);
    if (isNaN(sell) || sell < 0) return 0;
    return sell;
  }

  /**
   * Selected skin (Step A / skin_products) variant price in cents.
   * @returns {number}
   */
  function getMainComponentPriceCents() {
    return (state.skin && state.skin.priceCents) || 0;
  }

  function updatePriceDisplay() {
    if (!priceEl) return;

    if (priceFromMainComponent && !(state.skin && state.skin.variantId)) {
      priceEl.innerHTML = '';
      return;
    }

    var sell = getBundlePriceCents();
    var sum = getSelectedItemsSumCents();

    var sellHtml = '<ins>' + formatMoney(sell) + '</ins>';
    if (!priceFromMainComponent && sum > sell) {
      priceEl.innerHTML = '<del>' + formatMoney(sum) + '</del>' + sellHtml;
      return;
    }

    priceEl.innerHTML = sellHtml;
  }

  function updateAtc() {
    if (!atcBtn) return;
    var ready = isReady();
    atcBtn.disabled = !ready;
    atcBtn.classList.remove('byr__atc-btn--loading');

    if (!atcTextEl) return;

    if (ready) {
      atcTextEl.textContent = 'Add to bag';
      return;
    }

    var next = completedCount() + 1;
    if (next > 3) next = 3;
    atcTextEl.innerHTML = 'Complete step<br>' + next + ' of 3';
  }

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg || '';
    errorEl.classList.toggle('byr__error--visible', !!msg);
  }

  function getSelectedComponents() {
    return roles.map(function (role) {
      return { role: role, variantId: state[role].variantId };
    });
  }

  function makeInstanceId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'byr-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function addBundleToCart(components) {
    var qty = getQty();
    var instanceId = makeInstanceId();
    var resolvedBundlePrice = String(getBundlePriceCents());
    var mainComponentPrice = String(getMainComponentPriceCents());
    var items = components.map(function (c) {
      var properties = {
        _bundle_campaign: campaignId,
        _bundle_instance: instanceId,
        _bundle_role: c.role,
        _bundle_order: String(roles.indexOf(c.role) + 1),
        __bundle_component: 'true',
        __bundle_parent_item: String(parentVariantId),
        __bundle_price: resolvedBundlePrice,
      };

      if (priceFromMainComponent) {
        properties.__final_bundle_price = mainComponentPrice;
      }

      return {
        id: parseInt(c.variantId, 10),
        quantity: qty,
        properties: properties,
      };
    });

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(
          function (d) {
            var msg =
              (d && (d.description || d.message)) ||
              'Unable to add to bag.';
            throw new Error(msg);
          },
          function () {
            throw new Error('Unable to add to bag.');
          }
        );
      }
      return r.json();
    });
  }

  function openCartDrawer() {
    /* T4S Unsen: cart:refresh updates contents only.
      cart:refresh:opend refreshes then opens the slide cart
      (same path as native PDP add-to-bag). */
      document.dispatchEvent(
      new CustomEvent('cart:refresh:opend', { bubbles: true })
    );
  }

  /* ── Events ────────────────────────────────────────────── */

  root.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-byr-toggle]');
    if (toggle && root.contains(toggle)) {
      var role = toggle.getAttribute('data-byr-toggle');
      if (isStepLocked(role)) return;

      var step = stepEl(role);
      if (step && step.classList.contains('byr__step--open')) {
        setStepOpen(role, false);
      } else {
        openStep(role);
      }
      return;
    }

    var card = e.target.closest('[data-byr-product]');
    if (card && root.contains(card)) {
      var stepFromCard = card.closest('[data-byr-step]');
      if (!stepFromCard) return;
      selectProduct(stepFromCard.getAttribute('data-byr-step'), card);
      return;
    }

    var variantBtn = e.target.closest('.byr__variant');
    if (variantBtn && root.contains(variantBtn)) {
      var stepFromVar = variantBtn.closest('[data-byr-step]');
      if (!stepFromVar) return;
      onVariantClick(stepFromVar.getAttribute('data-byr-step'), variantBtn);
    }
  });

  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      if (atcBtn.disabled || !isReady()) return;
      showError('');
      atcBtn.classList.add('byr__atc-btn--loading');
      if (atcTextEl) atcTextEl.textContent = 'Adding…';

      addBundleToCart(getSelectedComponents())
        .then(function () {
          openCartDrawer();
          if (atcTextEl) atcTextEl.textContent = 'Added';
          setTimeout(function () {
            atcBtn.classList.remove('byr__atc-btn--loading');
            updateAtc();
          }, 2500);
        })
        .catch(function (err) {
          atcBtn.classList.remove('byr__atc-btn--loading');
          updateAtc();
          showError((err && err.message) || 'Something went wrong.');
        });
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var q = parseInt(qtyInput.value, 10);
      if (isNaN(q) || q < 1) {
        qtyInput.value = '1';
      } else {
        qtyInput.value = String(q);
      }
    });
  }

  /* Qty ± when theme handlers are absent */
  root.querySelectorAll('[data-decrease-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var q = getQty();
      if (q > 1) {
        qtyInput.value = String(q - 1);
        qtyInput.dispatchEvent(new Event('change'));
      }
    });
  });
  root.querySelectorAll('[data-increase-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var q = getQty();
      var max = parseInt(qtyInput.getAttribute('max'), 10) || 9999;
      if (q < max) {
        qtyInput.value = String(q + 1);
        qtyInput.dispatchEvent(new Event('change'));
      }
    });
  });

  /* ── Init ──────────────────────────────────────────────── */

  roles.forEach(function (role, i) {
    if (i === 0) {
      setStepOpen(role, true);
    } else {
      setStepOpen(role, false);
    }
  });
  syncStepClasses();
  updatePriceDisplay();
  updateAtc();
})();
